/* eslint-disable  */

(function (Drupal, $) {
  Drupal.behaviors.footer = {
    attach(context) {
      'use strict';

      $('.menu-footer >.menu-footer__item.has-children').click(function (e) {
        if ($(window).width() < 1024) {
          e.preventDefault();
          e.stopPropagation();
          const $this = $(this);
          $this.siblings().removeClass('active');
          $this.siblings().find('.menu-footer__submenu').slideUp('active');
          $this.toggleClass('active');
          $this.find('.menu-footer__submenu').slideToggle(300);
        }
      });

      $('.menu-footer >.menu-footer__item.has-children a.menu-footer__link').click(function (e) {
        if ($(window).width() < 1024) {
          e.stopPropagation();
        }
      });
    },
  };
})(Drupal, jQuery);
